import { Injectable } from '@angular/core'
import { CacheAPIService, CacheData, AnalysisListItem, ExtractionMethodListItem } from '@resultsgate-ui/api'
import { SelectItem } from '@resultsgate-ui/shared'

@Injectable({
    providedIn: 'root',
})
export class CacheService {
    rootCategoriesSelectItems: SelectItem<number>[] = []
    categoriesMap: Map<number, SelectItem<number>[]> = new Map()
    allCategoriesMap: Map<number, string> = new Map()

    analysisMap: Map<number, SelectItem<number>> = new Map()
    extractionMethodMap: Map<number, SelectItem<number>> = new Map()
    extractionMethodSelectItems: SelectItem<number>[]
    analysisSelectItems: SelectItem<number>[] = []
    analysisSelectItemsInclDisabled: SelectItem<number>[] = []
    analysisCache: Map<number, AnalysisListItem> = new Map()
    extMethodCache: Map<number, ExtractionMethodListItem> = new Map()

    resolutionDone = false

    constructor(private api: CacheAPIService) {
        console.log(`cache service constructor`)
    }

    public init() {
        return this.api
            .getCacheData()
            .toPromise()
            .then((data) => {
                console.log('cache init resolve true')
                this.createSelectItems(data)
                this.resolutionDone = true
                return true
            })
            .catch((e) => {
                console.log('cache init resolve false - error')
                return false
            })
    }
    createSelectItems(data: CacheData) {
        data.categoriesCache.reduce((agg, current) => {
            if (!current.parentId) {
                agg[current.id] = []
                this.rootCategoriesSelectItems.push({ id: current.id, label: current.name })
            }
            agg[current.parentId] = agg[current.parentId] || []
            agg[current.parentId].push({ id: current.id, label: current.name, group: current.parentId })
            this.allCategoriesMap.set(current.id, current.name)
            return agg
        }, this.categoriesMap)

        this.extractionMethodSelectItems = data.extractionMethodCache.map((em) => {
            const selItem = {
                id: em.id,
                label: em.name,
            }
            this.extractionMethodMap.set(em.id, selItem)
            return selItem
        })

        this.analysisSelectItems = data.analysisCache
            .filter((al) => !al.disabled)
            .map((al) => {
                const selItem = {
                    id: al.id,
                    label: `${al.name} ${al.description}`,
                }
                this.analysisMap.set(al.id, selItem)
                return selItem
            })
            .sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()))
        // hm what is this
        data.analysisCache.forEach((al) => {
            this.analysisSelectItemsInclDisabled.push({
                id: al.id,
                label: al.name,
            })
            this.analysisCache.set(al.id, al)
        })
        this.analysisSelectItemsInclDisabled.sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()))
    }
}
